import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString } from "vue"

import { useDateFormat } from "@vueuse/core";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateFormatted',
  props: {
    format: {},
    datetimeString: {}
  },
  setup(__props: any) {

const props = __props;

const formatted = useDateFormat(
  props.datetimeString,
  props.format ?? "DD.MM.YYYY HH:mm:ss",
  { locales: "de-DE" }
);

return (_ctx: any,_cache: any) => {
  return _toDisplayString(_unref(formatted))
}
}

})